import React, { useState, useMemo, useEffect } from 'react';

import { getContactSubTypeName } from '@libs/NwCustomerTypes';

import { useUserPermission } from '@contexts/UserContext';

//import { useContact } from "@hooks/Contact/UseContact";
import { useContactBillingInfos } from '@hooks/API/Contact/UseContactBillingInfos';

import BillingInfoForm from '@components/BillingInfos/BillingInfoForm';
import BillingInfoItem from '@components/BillingInfos/BillingInfoItem';
import { Loading } from '@components/Gui/Loading';
import { NwAddButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import SystemMessage from '@components/Utils/SystemMessage';

const BillingInfoDrawer = ({ contactId, type, subtype, readOnly, onClose }) => {
    //const { data: currentContact } = useContact(contactId)
    const { data: billingInfos, isFetching } = useContactBillingInfos(contactId);
    const [viewMode, setViewMode] = useState('LISTING'); // LISTING, VIEWING, INSERTING
    const [billingItem, setCurrentBillingItem] = useState(null);
    const [touchForm, setTouchForm] = useState(false);

    const canViewBillingInfos = useUserPermission('ViewBillingInfos');
    const canChangeBillingInfos = useUserPermission('ChangeBillingInfos');

    const handleCancelEdit = () => {
        setCurrentBillingItem(null);
        setViewMode('LISTING');
    };

    const billingInfoList = useMemo(() => {
        if (!isFetching && billingInfos && billingInfos.length > 0) {
            let sortedBillingInfos = [...billingInfos];
            sortedBillingInfos.sort((item1, item2) => (!item1.Disabled || (item1.Disabled && item2.Disabled) ? -1 : 1));
            sortedBillingInfos.sort((item1, item2) => (item1.isDefault ? -1 : 1));
            return sortedBillingInfos;
        }
    }, [billingInfos, isFetching]);

    const typeForCode = type.toLowerCase() === 'model' ? 'model' : getContactSubTypeName(subtype).toLowerCase();

    if (!canViewBillingInfos) {
        return <SystemMessage type="not-allowed" />;
    }

    return (
        <NwDrawer onClose={onClose} title="Billing Profiles" whiteBg={false}>
            {!readOnly && (
                <div className="drawer-toolbar-container">
                    <NwAddButton
                        primary
                        disabled={!canChangeBillingInfos}
                        onClick={() => {
                            setViewMode('INSERTING');
                        }}
                        label="Add a new billing profile"
                    />
                </div>
            )}
            <div className="drawer-content standard">
                {!isFetching ? (
                    billingInfoList &&
                    billingInfoList.length > 0 &&
                    billingInfoList.map((item) => (
                        <BillingInfoItem
                            key={item.ID}
                            isDefault={item.isDefault}
                            item={item}
                            type={type}
                            contactId={contactId}
                            onEditDoc={() => {
                                setCurrentBillingItem(item);
                                setViewMode('EDITING');
                            }}
                        />
                    ))
                ) : (
                    <div className="drawer-content-loading">
                        <Loading />
                    </div>
                )}
            </div>
            {viewMode === 'INSERTING' && (
                <NwDrawer
                    className="billinginfo-form-drawer"
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title="Add Billing Profile"
                    onClose={handleCancelEdit}
                >
                    <BillingInfoForm
                        type={typeForCode}
                        ContactID={contactId}
                        onCancel={handleCancelEdit}
                        onTouchForm={setTouchForm}
                    />
                </NwDrawer>
            )}
            {viewMode === 'EDITING' && (
                <NwDrawer
                    className="billinginfo-form-drawer"
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title="Edit Billing Profile"
                    onClose={handleCancelEdit}
                >
                    <BillingInfoForm
                        type={typeForCode}
                        ContactID={contactId}
                        billingInfo={billingItem}
                        onCancel={handleCancelEdit}
                        onTouchForm={setTouchForm}
                    />
                </NwDrawer>
            )}
        </NwDrawer>
    );
};

export default BillingInfoDrawer;
